/* eslint-disable */
/**
 * DO NOT EDIT!
 * THIS IS AUTOMATICALLY GENERATED FILE
 */

export enum ELanguageLabel {
  UK = 'uk',
  EN = 'en',
  FR = 'fr',
  ES = 'es',
  DE = 'de',
}

export type TLanguageLabel = 'alert.domain_selection_available'
  | 'alert.no_action_required'
  | 'btn.accept'
  | 'btn.add_domain'
  | 'btn.add_link'
  | 'btn.add_member'
  | 'btn.add_rule'
  | 'btn.all'
  | 'btn.cancel'
  | 'btn.change_picture'
  | 'btn.choose'
  | 'btn.clear'
  | 'btn.close'
  | 'btn.confirm'
  | 'btn.create'
  | 'btn.create_an_account'
  | 'btn.create_and_customize_design'
  | 'btn.create_folder'
  | 'btn.create_qrcode'
  | 'btn.create_template'
  | 'btn.current_plan'
  | 'btn.delete'
  | 'btn.delete_account'
  | 'btn.down'
  | 'btn.edit_design'
  | 'btn.edit_settings'
  | 'btn.edit_team'
  | 'btn.end_session'
  | 'btn.forgot_password'
  | 'btn.go_to_sign_in_page'
  | 'btn.later'
  | 'btn.leave_the_team'
  | 'btn.monthly'
  | 'btn.next'
  | 'btn.no'
  | 'btn.preview'
  | 'btn.qrcode_dynamic'
  | 'btn.qrcode_static'
  | 'btn.qrcode_types'
  | 'btn.remove'
  | 'btn.resend_code'
  | 'btn.reset_form_to_default_design'
  | 'btn.save'
  | 'btn.save_and_close'
  | 'btn.save_as_image'
  | 'btn.send'
  | 'btn.settings'
  | 'btn.sign_in'
  | 'btn.sign_in_existing'
  | 'btn.sign_in_with_google'
  | 'btn.sign_out'
  | 'btn.sign_up'
  | 'btn.sign_up_with_google'
  | 'btn.still_having_problems'
  | 'btn.subscribe'
  | 'btn.subscribe_now'
  | 'btn.subscribe_now_the'
  | 'btn.switch_team'
  | 'btn.trash'
  | 'btn.up'
  | 'btn.update'
  | 'btn.update_and_customize_design'
  | 'btn.verify_dns'
  | 'btn.view_plans'
  | 'btn.yearly'
  | 'btn.yes'
  | 'choice.account_time_zone'
  | 'choice.between'
  | 'choice.bug_or_technical_issues'
  | 'choice.choose'
  | 'choice.domain_status_active'
  | 'choice.domain_status_disabled'
  | 'choice.domain_status_pending'
  | 'choice.domain_status_pending_dns'
  | 'choice.domain_status_pending_ssl'
  | 'choice.domain_status_rejected'
  | 'choice.equals'
  | 'choice.event'
  | 'choice.feedback_or_suggestions'
  | 'choice.group'
  | 'choice.high'
  | 'choice.highest'
  | 'choice.in'
  | 'choice.invoice_and_payment'
  | 'choice.large'
  | 'choice.linear'
  | 'choice.low'
  | 'choice.medium'
  | 'choice.messenger_chat'
  | 'choice.no_folder'
  | 'choice.no_longer_needed'
  | 'choice.not_equals'
  | 'choice.not_useful'
  | 'choice.other'
  | 'choice.others'
  | 'choice.page'
  | 'choice.privacy_concerns'
  | 'choice.profile'
  | 'choice.radial'
  | 'choice.refund_policy'
  | 'choice.select_reason'
  | 'choice.small'
  | 'choice.technical_issues'
  | 'date.day.friday'
  | 'date.day.monday'
  | 'date.day.saturday'
  | 'date.day.sunday'
  | 'date.day.thursday'
  | 'date.day.tuesday'
  | 'date.day.wednesday'
  | 'date.last.14_days'
  | 'date.last.180_days'
  | 'date.last.30_days'
  | 'date.last.60_days'
  | 'date.last.7_days'
  | 'date.last.90_days'
  | 'date.lifetime'
  | 'date.month.april'
  | 'date.month.august'
  | 'date.month.december'
  | 'date.month.february'
  | 'date.month.january'
  | 'date.month.july'
  | 'date.month.june'
  | 'date.month.march'
  | 'date.month.may'
  | 'date.month.november'
  | 'date.month.october'
  | 'date.month.september'
  | 'date.plural.day'
  | 'date.plural.hour'
  | 'date.plural.minute'
  | 'date.plural.month'
  | 'date.plural.week'
  | 'date.plural.year'
  | 'date.short.day.fri'
  | 'date.short.day.mon'
  | 'date.short.day.sat'
  | 'date.short.day.sun'
  | 'date.short.day.thu'
  | 'date.short.day.tue'
  | 'date.short.day.wed'
  | 'date.short.month.apr'
  | 'date.short.month.aug'
  | 'date.short.month.dec'
  | 'date.short.month.feb'
  | 'date.short.month.jan'
  | 'date.short.month.jul'
  | 'date.short.month.jun'
  | 'date.short.month.mar'
  | 'date.short.month.may'
  | 'date.short.month.nov'
  | 'date.short.month.oct'
  | 'date.short.month.sep'
  | 'date.today'
  | 'date.yesterday'
  | 'fill_field.connect_with_us_on_social_media'
  | 'fill_field.mobile_app_desc'
  | 'fill_field.mobile_app_title'
  | 'fill_field.please_provide_your_feedback'
  | 'fill_field.sorry_our_services_meet_your_expectations'
  | 'fill_field.stay_connected_social_media'
  | 'form.check_again'
  | 'form.filling'
  | 'form.invalid'
  | 'form.invalid_file_extension'
  | 'form.some_errors'
  | 'hint.added_domain_success'
  | 'hint.cloudflare_dns_only_hint'
  | 'hint.contact_support_for_redirects'
  | 'hint.dns_https_cname_instruction'
  | 'hint.domain'
  | 'hint.domain_added_success'
  | 'hint.domain_connection_failed'
  | 'hint.domain_inactive'
  | 'hint.domain_links_unavailable'
  | 'hint.domain_ready_to_use'
  | 'hint.domain_routing'
  | 'hint.domain_unavailable'
  | 'hint.hostname'
  | 'hint.keep_existing_ssl_record'
  | 'hint.paypal_static.allow_amount_edit'
  | 'hint.paypal_static.amount'
  | 'hint.paypal_static.cancel_url'
  | 'hint.paypal_static.currency'
  | 'hint.paypal_static.description'
  | 'hint.paypal_static.expires_at'
  | 'hint.paypal_static.locale'
  | 'hint.paypal_static.recipient'
  | 'hint.paypal_static.recipient_name'
  | 'hint.paypal_static.reference'
  | 'hint.paypal_static.single_use'
  | 'hint.paypal_static.success_url'
  | 'hint.paypal_static.type'
  | 'hint.pix_static.amount'
  | 'hint.pix_static.category_code'
  | 'hint.pix_static.charge_type'
  | 'hint.pix_static.comment'
  | 'hint.pix_static.customer_can_change_value'
  | 'hint.pix_static.description'
  | 'hint.pix_static.due_date'
  | 'hint.pix_static.expiration'
  | 'hint.pix_static.merchant_city'
  | 'hint.pix_static.merchant_name'
  | 'hint.pix_static.mode'
  | 'hint.pix_static.pix_key'
  | 'hint.pix_static.pix_key_type'
  | 'hint.pix_static.pix_url'
  | 'hint.pix_static.txid'
  | 'hint.pix_static.validate_after_expiration'
  | 'hint.replace_existing_record'
  | 'hint.smart_link.default_url'
  | 'hint.smart_link.target_url'
  | 'hint.ssl_dns_record_do_not_delete'
  | 'hint.ssl_setup_in_progress'
  | 'hint.ttl_auto_or_default'
  | 'hint.upi_am'
  | 'hint.upi_mc'
  | 'hint.upi_payee_id'
  | 'hint.upi_pn'
  | 'hint.upi_tn'
  | 'hint.upi_tr'
  | 'hint.upi_url'
  | 'hint.uri'
  | 'label.active'
  | 'label.address'
  | 'label.address_work'
  | 'label.age'
  | 'label.age_gated'
  | 'label.agree'
  | 'label.allow_amount_edit'
  | 'label.amount'
  | 'label.app_start_code'
  | 'label.automatic_redirection'
  | 'label.background_image'
  | 'label.beneficiary_name'
  | 'label.bic'
  | 'label.bitcoin_receiver'
  | 'label.button_text'
  | 'label.cancel_url'
  | 'label.category_purpose_code'
  | 'label.charge_type'
  | 'label.city'
  | 'label.company_name'
  | 'label.configured'
  | 'label.confirm_new_password'
  | 'label.country'
  | 'label.country_code'
  | 'label.cryptocurrency'
  | 'label.currency'
  | 'label.customer_can_change_value'
  | 'label.default_url'
  | 'label.description'
  | 'label.device'
  | 'label.dns_record'
  | 'label.dns_record_name'
  | 'label.dns_record_value'
  | 'label.dns_routing'
  | 'label.domain'
  | 'label.domain_not_found_redirect_url'
  | 'label.domain_root_redirect_url'
  | 'label.due_date'
  | 'label.email'
  | 'label.enable'
  | 'label.enable_dark_mode'
  | 'label.enable_link_to_pdf'
  | 'label.enable_rtl_mode'
  | 'label.encoding'
  | 'label.encryption_type'
  | 'label.error_correction_level'
  | 'label.event_description'
  | 'label.event_dt_end'
  | 'label.event_dt_start'
  | 'label.event_location'
  | 'label.event_title'
  | 'label.expiration'
  | 'label.expires_at'
  | 'label.first_name'
  | 'label.folder'
  | 'label.frame_color'
  | 'label.frame_text'
  | 'label.function'
  | 'label.gradient'
  | 'label.gradient_type'
  | 'label.headline'
  | 'label.hidden_network'
  | 'label.hostname'
  | 'label.iban'
  | 'label.id_or_username'
  | 'label.instagram_link'
  | 'label.is_working'
  | 'label.language'
  | 'label.last_name'
  | 'label.limit'
  | 'label.link'
  | 'label.linkedin_link'
  | 'label.locale'
  | 'label.merchant_category_code'
  | 'label.merchant_name'
  | 'label.message'
  | 'label.mode'
  | 'label.more_details_optional'
  | 'label.name'
  | 'label.network_name_wifi'
  | 'label.new_password'
  | 'label.note'
  | 'label.old_password'
  | 'label.operator'
  | 'label.pa'
  | 'label.password'
  | 'label.password_confirmation'
  | 'label.payment_note'
  | 'label.payment_purpose'
  | 'label.phone_number'
  | 'label.phone_work'
  | 'label.pix_key'
  | 'label.pix_key_type'
  | 'label.pix_url'
  | 'label.pn'
  | 'label.postal_code'
  | 'label.purpose'
  | 'label.purpose_code'
  | 'label.question'
  | 'label.reason'
  | 'label.reason_for_account_deletion'
  | 'label.receiver_email'
  | 'label.recipient_code'
  | 'label.recipient_id'
  | 'label.recipient_name'
  | 'label.reference'
  | 'label.remember_me'
  | 'label.remittance_information'
  | 'label.remove_background_behind_logo'
  | 'label.resource_type'
  | 'label.role'
  | 'label.rotation'
  | 'label.schedule_active'
  | 'label.schedule_from'
  | 'label.schedule_to'
  | 'label.search_google_maps'
  | 'label.signature'
  | 'label.single_use'
  | 'label.site_language'
  | 'label.size'
  | 'label.source_label'
  | 'label.ssl_certificate'
  | 'label.ssl_dns_record'
  | 'label.ssl_dns_record_name'
  | 'label.ssl_dns_record_value'
  | 'label.state'
  | 'label.status'
  | 'label.street'
  | 'label.sub_headline'
  | 'label.subject'
  | 'label.success_url'
  | 'label.target_url'
  | 'label.team_name'
  | 'label.telegram_use_phone_number'
  | 'label.template_name'
  | 'label.text'
  | 'label.text_color'
  | 'label.theme'
  | 'label.tiktok_link'
  | 'label.title'
  | 'label.twitter_link'
  | 'label.txid'
  | 'label.type'
  | 'label.tz'
  | 'label.upi_url'
  | 'label.uri'
  | 'label.url'
  | 'label.use_default'
  | 'label.use_web_link'
  | 'label.valid_until'
  | 'label.validate_after_expiration'
  | 'label.version'
  | 'label.viber_type_add'
  | 'label.viber_type_chat'
  | 'label.viber_type_forward'
  | 'label.viber_type_keypad'
  | 'label.website'
  | 'label.website_url'
  | 'label.youtube_link'
  | 'label.zip_code'
  | 'menu.account'
  | 'menu.active'
  | 'menu.analytics'
  | 'menu.archived'
  | 'menu.authorized_devices'
  | 'menu.collapsed_view'
  | 'menu.contact_us'
  | 'menu.domains'
  | 'menu.my_teams'
  | 'menu.pricing'
  | 'menu.privacy_policy'
  | 'menu.profile'
  | 'menu.qr_codes'
  | 'menu.security'
  | 'menu.teams'
  | 'menu.templates'
  | 'menu.terms'
  | 'modal.confirm_delete_domain.paragraph'
  | 'modal.confirm_delete_domain.paragraph2'
  | 'modal.confirm_delete_domain.title'
  | 'msg.accept_policy_link'
  | 'msg.add_custom_domain'
  | 'msg.add_your_first_template_to_easily_reuse_the_design'
  | 'msg.all_entries'
  | 'msg.app_update'
  | 'msg.auth001'
  | 'msg.auth004'
  | 'msg.auth006'
  | 'msg.auth010'
  | 'msg.auth011'
  | 'msg.auth014'
  | 'msg.auth015'
  | 'msg.auth_access_denied'
  | 'msg.auth_access_restricted'
  | 'msg.auto_domain_assignment'
  | 'msg.error'
  | 'msg.error_downloading_qrcode'
  | 'msg.error_printing_qrcode'
  | 'msg.fc1000'
  | 'msg.fc1001'
  | 'msg.fc1002'
  | 'msg.fc1003'
  | 'msg.fc1004'
  | 'msg.fc1005'
  | 'msg.fc1006'
  | 'msg.fc1007'
  | 'msg.fc1008'
  | 'msg.fc1009'
  | 'msg.fc1010'
  | 'msg.fc1011'
  | 'msg.fc1012'
  | 'msg.fc1013'
  | 'msg.fc1014'
  | 'msg.fc1015'
  | 'msg.fc1016'
  | 'msg.fc1017'
  | 'msg.fc1018'
  | 'msg.fc1019'
  | 'msg.fc1020'
  | 'msg.fc1021'
  | 'msg.fc1022'
  | 'msg.fc1023'
  | 'msg.fc1024'
  | 'msg.fc1025'
  | 'msg.fc1026'
  | 'msg.fc1027'
  | 'msg.fc1028'
  | 'msg.fc1029'
  | 'msg.fc1030'
  | 'msg.fc1031'
  | 'msg.fc1032'
  | 'msg.file_format_not_supported'
  | 'msg.file_size_limit'
  | 'msg.info'
  | 'msg.invitation_sent_at'
  | 'msg.link_domain_to_server'
  | 'msg.no_qr_code_was_found'
  | 'msg.no_templates_yet'
  | 'msg.non_trackable'
  | 'msg.or_use_email'
  | 'msg.qrcode_not_found'
  | 'msg.reason.too_many_attempts'
  | 'msg.smart_link.desc_rules'
  | 'msg.success'
  | 'msg.successfully.created'
  | 'msg.successfully.deleted'
  | 'msg.successfully.updated'
  | 'msg.t1'
  | 'msg.t1000'
  | 'msg.t1001'
  | 'msg.t1002'
  | 'msg.t1004'
  | 'msg.t1005'
  | 'msg.t1006'
  | 'msg.t1007'
  | 'msg.t1008'
  | 'msg.t1010'
  | 'msg.t1011'
  | 'msg.t1012'
  | 'msg.t2'
  | 'msg.t2001'
  | 'msg.t2002'
  | 'msg.t2006'
  | 'msg.t2200'
  | 'msg.t2201'
  | 'msg.t2202'
  | 'msg.t3'
  | 'msg.team004'
  | 'msg.team005'
  | 'msg.team007'
  | 'msg.telegram_country_code_hint'
  | 'msg.telegram_message_hint'
  | 'msg.telegram_phone_number_hint'
  | 'msg.telegram_target_hint'
  | 'msg.thank_you_for_contacting_us'
  | 'msg.tiktok_target_hint'
  | 'msg.tiktok_use_web_link'
  | 'msg.total_pages'
  | 'msg.total_scans'
  | 'msg.twitter_target_hint'
  | 'msg.untitled'
  | 'msg.upgrade_plan_custom_domains'
  | 'msg.upload_error'
  | 'msg.viber_country_code_hint'
  | 'msg.viber_message_hint'
  | 'msg.viber_number_hint'
  | 'msg.viber_phone_number_hint'
  | 'msg.viber_type_hint'
  | 'msg.warning'
  | 'msg.whatsapp_country_code_hint'
  | 'msg.whatsapp_message_hint'
  | 'msg.whatsapp_phone_number_hint'
  | 'msg.youtube_target_hint'
  | 'page_title.access_to_teams'
  | 'page_title.analytics'
  | 'page_title.archived_qr_codes'
  | 'page_title.authorized_devices'
  | 'page_title.contact_us'
  | 'page_title.create_new_qrcode_template'
  | 'page_title.edit_profile'
  | 'page_title.edit_qrcode_template'
  | 'page_title.forgot_password'
  | 'page_title.new_qrcode'
  | 'page_title.overview'
  | 'page_title.qrcode_design'
  | 'page_title.qrcode_setting'
  | 'page_title.qrcode_view'
  | 'page_title.reset_password'
  | 'page_title.security'
  | 'page_title.sign_in'
  | 'page_title.sign_out'
  | 'page_title.sign_up'
  | 'page_title.team_members'
  | 'page_title.verify_email'
  | 'placeholder.allowed_file_types'
  | 'placeholder.caption'
  | 'placeholder.choose_date'
  | 'placeholder.confirm_new_password'
  | 'placeholder.confirm_password'
  | 'placeholder.confirmation_code'
  | 'placeholder.domain_not_found_redirect_url_default'
  | 'placeholder.domain_root_redirect_url_default'
  | 'placeholder.eg_url'
  | 'placeholder.email'
  | 'placeholder.event_location'
  | 'placeholder.event_title'
  | 'placeholder.first_name'
  | 'placeholder.headline'
  | 'placeholder.last_name'
  | 'placeholder.link_eg'
  | 'placeholder.link_name'
  | 'placeholder.message'
  | 'placeholder.name_of_your_qrcode'
  | 'placeholder.network_name_wifi'
  | 'placeholder.new_password'
  | 'placeholder.password'
  | 'placeholder.phone'
  | 'placeholder.question'
  | 'placeholder.sub_headline'
  | 'placeholder.subject'
  | 'placeholder.template_name'
  | 'placeholder.tz'
  | 'placeholder.upload_pdf'
  | 'placeholder.website'
  | 'qrcode.bank_transfer_epc_static.desc'
  | 'qrcode.bank_transfer_epc_static.title'
  | 'qrcode.bank_transfer_ua.desc'
  | 'qrcode.bank_transfer_ua.title'
  | 'qrcode.bank_transfer_ua_static.desc'
  | 'qrcode.bank_transfer_ua_static.title'
  | 'qrcode.bitcoin_static.desc'
  | 'qrcode.bitcoin_static.title'
  | 'qrcode.email.desc'
  | 'qrcode.email.title'
  | 'qrcode.email_static.desc'
  | 'qrcode.email_static.title'
  | 'qrcode.facebook.desc'
  | 'qrcode.facebook.title'
  | 'qrcode.facebook_static.desc'
  | 'qrcode.facebook_static.title'
  | 'qrcode.image_gallery.desc'
  | 'qrcode.image_gallery.title'
  | 'qrcode.instagram.desc'
  | 'qrcode.instagram.title'
  | 'qrcode.instagram_static.desc'
  | 'qrcode.instagram_static.title'
  | 'qrcode.linkedin.desc'
  | 'qrcode.linkedin.title'
  | 'qrcode.linkedin_static.desc'
  | 'qrcode.linkedin_static.title'
  | 'qrcode.location.desc'
  | 'qrcode.location.title'
  | 'qrcode.mobile_app.desc'
  | 'qrcode.mobile_app.title'
  | 'qrcode.paypal_static.desc'
  | 'qrcode.paypal_static.title'
  | 'qrcode.pdf.desc'
  | 'qrcode.pdf.title'
  | 'qrcode.phone_call.desc'
  | 'qrcode.phone_call.title'
  | 'qrcode.phone_call_static.desc'
  | 'qrcode.phone_call_static.title'
  | 'qrcode.pix_static.desc'
  | 'qrcode.pix_static.title'
  | 'qrcode.plain_text_static.desc'
  | 'qrcode.plain_text_static.title'
  | 'qrcode.smart_link.desc'
  | 'qrcode.smart_link.title'
  | 'qrcode.sms.desc'
  | 'qrcode.sms.title'
  | 'qrcode.sms_static.desc'
  | 'qrcode.sms_static.title'
  | 'qrcode.social_media.desc'
  | 'qrcode.social_media.title'
  | 'qrcode.telegram.desc'
  | 'qrcode.telegram.title'
  | 'qrcode.telegram_static.desc'
  | 'qrcode.telegram_static.title'
  | 'qrcode.tiktok.desc'
  | 'qrcode.tiktok.title'
  | 'qrcode.tiktok_static.desc'
  | 'qrcode.tiktok_static.title'
  | 'qrcode.twitter.desc'
  | 'qrcode.twitter.title'
  | 'qrcode.twitter_static.desc'
  | 'qrcode.twitter_static.title'
  | 'qrcode.upi_static.desc'
  | 'qrcode.upi_static.title'
  | 'qrcode.vcard.desc'
  | 'qrcode.vcard.title'
  | 'qrcode.vcard_static.desc'
  | 'qrcode.vcard_static.title'
  | 'qrcode.vevent_static.desc'
  | 'qrcode.vevent_static.title'
  | 'qrcode.viber.desc'
  | 'qrcode.viber.title'
  | 'qrcode.viber_static.desc'
  | 'qrcode.viber_static.title'
  | 'qrcode.website.desc'
  | 'qrcode.website.title'
  | 'qrcode.website_static.desc'
  | 'qrcode.website_static.title'
  | 'qrcode.whatsapp.desc'
  | 'qrcode.whatsapp.title'
  | 'qrcode.whatsapp_static.desc'
  | 'qrcode.whatsapp_static.title'
  | 'qrcode.wifi_connection_static.desc'
  | 'qrcode.wifi_connection_static.title'
  | 'qrcode.youtube.desc'
  | 'qrcode.youtube.title'
  | 'qrcode.youtube_static.desc'
  | 'qrcode.youtube_static.title'
  | 'tab.access_by_age'
  | 'tab.activation'
  | 'tab.background'
  | 'tab.basic_information'
  | 'tab.by_country'
  | 'tab.by_time_day'
  | 'tab.charts'
  | 'tab.configuration'
  | 'tab.destination'
  | 'tab.domain'
  | 'tab.frame'
  | 'tab.inner_marker_style'
  | 'tab.logo'
  | 'tab.module_style'
  | 'tab.outer_marker_style'
  | 'tab.password'
  | 'tab.scan_limit'
  | 'tab.scans'
  | 'tab.schedule_a_date'
  | 'tab.shape'
  | 'tab.ssl_certificate'
  | 'tab.sticker'
  | 'tab.templates'
  | 'tariff.feature.24_7_support'
  | 'tariff.feature.age_gated_qr_codes'
  | 'tariff.feature.dynamic_qr_codes'
  | 'tariff.feature.max_teams'
  | 'tariff.feature.max_users_per_team'
  | 'tariff.feature.multiple_download_formats'
  | 'tariff.feature.password_protected_qr_codes'
  | 'tariff.feature.qr_code_customizations'
  | 'tariff.feature.qr_code_scans'
  | 'tariff.feature.scan_analytics'
  | 'tariff.feature.schedule_of_qr_code_availability'
  | 'tariff.feature.static_qr_codes'
  | 'tariff.feature.track_scans_device_type'
  | 'tariff.feature.track_scans_gps_coordinates'
  | 'tariff.feature.track_scans_location'
  | 'tariff.feature.track_scans_time_of_day'
  | 'tariff.feature.variety_of_qr_types'
  | 'tariff.forever'
  | 'tariff.free'
  | 'tariff.included_all_packages'
  | 'tariff.most_popular'
  | 'th.added'
  | 'th.city'
  | 'th.country'
  | 'th.created'
  | 'th.customer'
  | 'th.device_name'
  | 'th.expires_at'
  | 'th.hostname'
  | 'th.joined'
  | 'th.last_used'
  | 'th.name'
  | 'th.owner'
  | 'th.role'
  | 'th.scans'
  | 'th.status'
  | 'th.type'
  | 'th.updated'
  | 'title.account_deletion'
  | 'title.add_dns_record_for_ssl'
  | 'title.add_domain'
  | 'title.additionally'
  | 'title.address_information'
  | 'title.age_restricted'
  | 'title.app_logo'
  | 'title.app_store_links'
  | 'title.archive_qr_codes'
  | 'title.authorized_devices'
  | 'title.available_to_me'
  | 'title.change_password'
  | 'title.contact_info'
  | 'title.contact_us'
  | 'title.cookie_manager'
  | 'title.copy'
  | 'title.country'
  | 'title.create_new_folder'
  | 'title.create_new_team'
  | 'title.create_template'
  | 'title.create_your_account_today'
  | 'title.created_on'
  | 'title.custom_domain_settings'
  | 'title.custom_domain_unavailable_on_plan'
  | 'title.delete_qrcode'
  | 'title.deletion_confirmation'
  | 'title.details'
  | 'title.domain_added'
  | 'title.domain_connection_rejected'
  | 'title.domain_disabled'
  | 'title.domain_ready_to_use'
  | 'title.domain_routing'
  | 'title.domains'
  | 'title.dynamic_qr_codes'
  | 'title.edit_domain'
  | 'title.edit_folder'
  | 'title.edit_member'
  | 'title.edit_template'
  | 'title.first_time_mobile_visits'
  | 'title.first_time_visits'
  | 'title.forgot_your_password'
  | 'title.get_access_to_your_account'
  | 'title.image'
  | 'title.important'
  | 'title.its_empty_here_for_now'
  | 'title.last_updated'
  | 'title.lets_fix_it_right_now'
  | 'title.links'
  | 'title.loading_'
  | 'title.logo_or_avatar'
  | 'title.members'
  | 'title.mobile_visits'
  | 'title.my_teams'
  | 'title.no_owned_domains'
  | 'title.no_qrcode_found'
  | 'title.note'
  | 'title.owners_email'
  | 'title.owners_full_name'
  | 'title.password_protected'
  | 'title.percentage_of_unique_scans'
  | 'title.personal_information'
  | 'title.please_verify_your_email'
  | 'title.preview'
  | 'title.pricing'
  | 'title.qrcode_analytics'
  | 'title.qrcode_design'
  | 'title.qrcode_details'
  | 'title.qrcodes'
  | 'title.redirecting'
  | 'title.route_transition'
  | 'title.rule'
  | 'title.rules'
  | 'title.scan_limit'
  | 'title.scans'
  | 'title.scans_by_country'
  | 'title.scans_by_time_day'
  | 'title.scans_per_code_average'
  | 'title.scheduled_access'
  | 'title.send_invitation'
  | 'title.session_info'
  | 'title.sign_in'
  | 'title.sign_up'
  | 'title.social_media'
  | 'title.ssl_certificate_verified'
  | 'title.static_qr_codes'
  | 'title.style_qr_code_using_colors_logos_and_more'
  | 'title.team_folders'
  | 'title.teams'
  | 'title.templates'
  | 'title.total_visits'
  | 'title.unique_scans'
  | 'title.update_team'
  | 'title.web_links'
  | 'title.working_hours'
  | 'tooltip.created'
  | 'tooltip.delete'
  | 'tooltip.download_qrcode'
  | 'tooltip.edit_design'
  | 'tooltip.edit_settings'
  | 'tooltip.flip_horizontal'
  | 'tooltip.flip_vertical'
  | 'tooltip.open_new_window'
  | 'tooltip.restore_from_trash'
  | 'tooltip.rotate_left'
  | 'tooltip.rotate_right'
  | 'tooltip.switch_theme'
  | 'tooltip.view'
  | 'validation.email'
  | 'validation.maxlength'
  | 'validation.minlength'
  | 'validation.pattern'
  | 'validation.required'
  | 'validation.url_format';

export type TLanguageLabelOrString = TLanguageLabel | string;
export type TLanguageLabelOrNever = TLanguageLabel | never;
export type TLanguageLabelKey = (typeof ELanguageLabel)[keyof typeof ELanguageLabel];
